import React from "react";

import { Card } from "primereact/card";
import { Button } from "primereact/button";

import styled from "styled-components";

const PoliticaPrivacidade = () => {

  const Divider = styled.hr`
    border: none;
    border-top: 1px solid #dcdcdc;
    margin: 1rem 0;
  `;

  const TextList = styled.div`
    margin: 16px 0;

    p {
        margin: 8px 0;
        line-height: 1.7;
    }
  `;

  return (
    <div
      className="p-d-flex p-jc-center p-p-5"
      style={{ background: '#f5f5f5', minHeight: '100vh', lineHeight: '1.5' }}
    >
      <Card style={{ maxWidth: '1000px', width: '100%' }}>

        <Button label="Voltar" icon="pi pi-arrow-left" onClick={() => window.history.back()} />

        <h1 className="p-text-center">Política de Privacidade</h1>

        <p>
          Nós da <strong>Hengel Logística e Comércio de Biomassa Ltda</strong> estamos
          comprometidos a prestar um ótimo serviço e de máxima qualidade. Além disso,
          também estamos preocupados com a privacidade de suas informações pessoais.
          Portanto, colocamos à sua disposição esta Política de Privacidade, a qual visa
          dar transparência ao tratamento de dados pessoais realizado pela nossa empresa.
          Nela informamos, de forma clara, sobre a coleta, armazenamento e as finalidades
          para as quais estes dados serão utilizados.
        </p>

        <p>
          Ressalta-se que, dentro dos limites da lei e do consentimento dos titulares,
          pode ocorrer o compartilhamento de dados com terceiros, sempre seguindo as
          determinações da Lei Geral de Proteção de Dados Pessoais (LGPD), as boas
          práticas de governança em privacidade sugeridas pelos órgãos competentes e
          respeitando a confiança atribuída pelos titulares de dados à Hengel Logística e
          Comércio de Biomassa Ltda.
        </p>

        <Divider />

        <h2>1. Das Definições</h2>

        <p>
          <strong>Dado pessoal:</strong> informação relacionada à pessoa natural
          identificada ou identificável.
        </p>

        <p>
          <strong>Dado pessoal sensível:</strong> dado pessoal sobre origem racial ou
          étnica, convicção religiosa, opinião política, filiação a sindicato ou a
          organização de caráter religioso, filosófico ou político; dado referente à
          saúde ou à vida sexual, dado genético ou biométrico, quando vinculado a uma
          pessoa natural.
        </p>

        <p>
          <strong>Titular:</strong> pessoa natural a quem se referem os dados pessoais que
          são objeto de tratamento.
        </p>

        <p>
          <strong>Controlador:</strong> pessoa natural ou jurídica, de direito público ou
          privado, a quem competem as decisões referentes ao tratamento de dados pessoais.
        </p>

        <p>
          <strong>Operador:</strong> pessoa natural ou jurídica, de direito público ou
          privado, que realiza o tratamento de dados pessoais em nome do controlador.
        </p>

        <p>
          <strong>Tratamento:</strong> toda operação realizada com dados pessoais, como
          coleta, produção, recepção, classificação, utilização, acesso, reprodução,
          transmissão, distribuição, processamento, arquivamento, armazenamento,
          eliminação, avaliação ou controle da informação, modificação, comunicação,
          transferência, difusão ou extração.
        </p>

        <Divider />

        <h2>2. Das Disposições Gerais</h2>

        <p>
          De acordo com o estabelecido pela LGPD, a empresa apenas coleta e trata os
          dados pessoais indispensáveis para que seja prestado o adequado serviço de
          transporte e logística. Assim, para atingir uma finalidade legítima, serão
          coletadas apenas as informações estritamente necessárias.
        </p>

        <p>
          A empresa poderá tratar dados pessoais dos seguintes titulares:
        </p>

        <TextList>
          <p>- Clientes;</p>
          <p>- Representantes legais de clientes;</p>
          <p>- Parceiros Comerciais;</p>
          <p>- Colaboradores;</p>
          <p>- Fornecedores;</p>
          <p>- Terceiros que mantenham relacionamento comercial ou operacional com a empresa;</p>
        </TextList>

        <p>
          - A empresa efetua a coleta de dados pessoais dos titulares para atingir uma
          finalidade específica. Deste modo, a coleta é sempre realizada por meios
          oficiais da empresa, tais como:
        </p>

        <TextList>
          <p>- Assinatura de contratos de prestação de serviços (parcerias ou trabalho);</p>
          <p>- Cadastro interno de colaboradores, parceiros ou terceiros;</p>
          <p>- Parceiros Comerciais;</p>
          <p>- Colaboradores;</p>
          <p>- Fornecedores;</p>
          <p>- Terceiros que mantenham relacionamento comercial ou operacional com a empresa;</p>
        </TextList>

        <p>
          Os dados tratados pela empresa serão armazenados durante a relação contratual,
          enquanto durar a finalidade de origem ou pelo prazo determinado por obrigação
          legal e/ou regulatória. Para obter mais informações sobre o prazo específico de
          armazenamento para cada categoria de dados, entre em contato pelos canais
          oficiais ou com o DPO através do e-mail <strong>ti@hengel.com.br</strong>.
        </p>

        <p>
          O compartilhamento dos dados poderá ocorrer entre os setores internos da empresa,
          bem como com fornecedores e parceiros responsáveis pelo suporte às atividades
          operacionais. Portanto, é possível que o compartilhamento ocorra com alguns
          fornecedores e/ou parceiros terceirizados para prestação de suporte ou promoção
          de serviços, tais como:
        </p>

        <TextList>
          <p>- Empresas de tecnologia da informação (Sistemas de Gestão, Suporte e Aplicativos);</p>
          <p>- Empresas de marketing e comunicação;</p>
          <p>- Softwares internos de gestão de informações, jurídica e financeira, entre outros.</p>
        </TextList>

        <p>
          O compartilhamento de dados também poderá ocorrer em razão de solicitações por
          autoridades administrativas ou judiciais, sempre após análise da legalidade e do
          amparo jurídico da solicitação.
        </p>

        <p>
          Como controlador e/ou operador dos dados pessoais, a empresa é responsável por
          mantê-los seguros dentro do seu ambiente e tratá-los apenas dentro dos limites
          informados nesta Política de Privacidade.
        </p>

        <Divider />

        <h2>3. Controlador e/ou Operador</h2>

        <p>
          <strong>Hengel Logística e Comércio de Biomassa Ltda</strong>
          <br />
          Qualificação completa.
        </p>

        <Divider />

        <h2>4. Canais de Comunicação</h2>

        <p>
          Para quaisquer informações, inclusive para o exercício dos direitos previstos na
          LGPD, entre em contato através do e-mail:
        </p>

        <p>
          <strong>ti@hengel.com.br</strong>
        </p>
      </Card>
    </div>
  );
};

export default PoliticaPrivacidade;